import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

import skill1 from '../assets/img/icons8-.net-framework.svg';
import skill2 from '../assets/img/icons8-spring-boot.svg';
import skill3 from '../assets/img/nextjs-icon-svgrepo-com.svg';
import skill4 from '../assets/img/react-svgrepo-com.svg';
import skill5 from '../assets/img/jquery-svgrepo-com.svg';
import skill6 from '../assets/img/icons8-css.svg';
import skill7 from '../assets/img/icons8-sql-server.svg';
import skill8 from '../assets/img/icons8-postgresql.svg';
import skill9 from '../assets/img/icons8-mongodb.svg';
import skill10 from '../assets/img/icons8-git.svg';
import skill11 from '../assets/img/docker-svgrepo-com.svg';
import skill12 from '../assets/img/python-svgrepo-com.svg'


export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>I develop scalable and high-performance applications using modern technologies.</p>
                        <Carousel
                        responsive={responsive}
                        infinite={true}
                        autoPlay={true}
                        autoPlaySpeed={1000}
                        keyBoardControl={true}
                        swipeable={true}
                        draggable={true}
                        className="owl-carousel owl-theme skill-slider"
                      >
                            <div className="item">
                                <img src={skill1} alt="Image" />
                                <h5>.NET</h5>
                            </div>
                            <div className="item">
                                <img src={skill2} alt="Image" />
                                <h5>Spring Boot</h5>
                            </div>
                            <div className="item">
                                <img src={skill3} alt="Image" />
                                <h5>NextJS</h5>
                            </div>
                            <div className="item">
                                <img src={skill4} alt="Image" />
                                <h5>ReactJS</h5>
                            </div>
                            <div className="item">
                                <img src={skill5} alt="Image" />
                                <h5>JQuery</h5>
                            </div>
                               <div className="item">
                                <img src={skill6} alt="Image" />
                                <h5>HTML/CSS</h5>
                            </div>
                            <div className="item">
                                <img src={skill12} alt="Image" />
                                <h5>Python</h5>
                            </div>
                              <div className="item">
                                <img src={skill7} alt="Image" />
                                <h5>SQL Server</h5>
                            </div>
                              <div className="item">
                                <img src={skill8} alt="Image" />
                                <h5>PostgreSQL</h5>
                            </div>
                               <div className="item">
                                <img src={skill9} alt="Image" />
                                <h5>MongoDB</h5>
                            </div>
                               <div className="item">
                                <img src={skill10} alt="Image" />
                                <h5>Git</h5>
                            </div>
                                <div className="item">
                                <img src={skill11} alt="Image" />
                                <h5>Docker</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
